<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  
  <!-- zone champs libres & filtre -->
   <wiz-vgroup width="240px" height="100%" style="padding-bottom: 2px;">
    <wiz-vgroup width="100%" height="100%" class="section-container"><!-- zone champs libres & filtre -->
      <wiz-label [wizLabel]="'$.pivot.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-list
        #freeList
        height="100%"
        width="100%"
        [wizItemRenderer]="renderer"
        id="freeList"
        [wizDataProvider]="dataSource"
        [wizLabelField]="'fullCode'"
        [dragEnabled]="true"
      ></wiz-list>
      <filter-component #mainFilter> </filter-component>
    </wiz-vgroup>
   </wiz-vgroup>

  <!-- zone détail -->  
  <wiz-vgroup #vgDetailZone width="100%" height="100%" style="padding-bottom: 2px;">
    
    <!-- tryptique --> 
    <wiz-hgroup width="100%" height="100%">
      
      <!-- Aggrégats en lignes, en colonnes & filtres -->  
      <wiz-vgroup width="240px" height="100%" style="padding-bottom: 2px;">
      
        <!-- champs lignes -->
      <wiz-vgroup width="100%" height="40%" class="section-container">
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-line</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.row.agg.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstRow
          id="lstRow"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>

      <!-- champs colonnes -->
      <wiz-vgroup width="100%" height="20%" class="section-container" [visible]="!isToolMode" ><!-- champs colonnes -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-column</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.column.agg.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstColumn
          id="lstColumn"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>

      <!-- champs filtres -->
      <wiz-vgroup width="100%" height="40%" class="section-container">
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-filters</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstFilter
          id="lstFilter"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>


      </wiz-vgroup>

      <!-- groupes de colonnes, contrôles d'intégrités & params -->  
      <wiz-vgroup width="240px" height="100%" style="padding-bottom: 2px;">

        <!-- groupes -->
        <wiz-vgroup width="100%" height="100%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon [wizTooltip]="'$.pivot.edit.field.groups.add.$'" class="image-back-orange" (click)="addGroup()">add</wiz-icon>
            <wiz-icon class="image-purple">icon-column</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.groups.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstGroup
            id="lstGroup"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="groupRenderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
          ></wiz-list>
        </wiz-vgroup>

        <!-- zone contrôle d'intégrité -->
        <wiz-vgroup width="100%" height="100%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-formula</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.integrity.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          
          <wiz-checkbox #cbDeleteIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.delete.$'"></wiz-checkbox>
          <wiz-list
            #lstIntegrity
            id="lstDeleteCheck"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
          <wiz-checkbox #cbUpdateIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.update.$'"></wiz-checkbox>
        </wiz-vgroup>

        <!-- params -->
        <wiz-vgroup width="100%" [visible]="!isToolMode" class="section-container">
          <wiz-vgroup>
            <wiz-checkbox #cbShowDeleteCol [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
            <wiz-checkbox #cbShowDeleteRecurseCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'"></wiz-checkbox>
            <wiz-hgroup>
              <wiz-checkbox #cbShowSelectCol [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
              <wiz-checkbox #cbSelectUnique [wizLabel]="'$.pivot.edit.select.unique.$'"></wiz-checkbox>
            </wiz-hgroup>
          </wiz-vgroup>
          <wiz-vgroup>
            <wiz-radio-group [wizValue]="1" #rgMassEditConfig>
              <wiz-radio-button [wizLabel]="'$.massedit.undefined.$'" [wizValue]="1"></wiz-radio-button>
              <wiz-radio-button [wizLabel]="'$.massedit.same.$'" [wizValue]="2"></wiz-radio-button>
              <wiz-radio-button [wizLabel]="'$.massedit.split.$'" [wizValue]="3"></wiz-radio-button>
            </wiz-radio-group>
          </wiz-vgroup>
        </wiz-vgroup>

      </wiz-vgroup>

      <!-- données -->  
      <wiz-vgroup width="100%" height="100%" style="padding-bottom: 2px;">
        <!-- champs datas -->
        <wiz-vgroup width="100%" height="100%" class="section-container">
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-formula</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.data.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstData
            id="lstData"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
          <wiz-checkbox #cbRevert [wizLabel]="'$.pivot.revert.$'"></wiz-checkbox>
        </wiz-vgroup>
      </wiz-vgroup>

    </wiz-hgroup>    

    <!-- zone de validation --> 
    <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
      <wiz-button
        #btnSave
        width="150px"
        (click)="doValid()"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        width="150px"
        (click)="doCancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>


  </wiz-vgroup>


</wiz-hgroup>
